// extracted by mini-css-extract-plugin
export var btn = "D_mY q_rV q_rw d_bz d_bP d_bD d_dw";
export var full = "D_vR d_w d_H";
export var hoverStyle = "D_m1";
export var zoom = "D_m2";